import { render } from "./DataTitle.vue?vue&type=template&id=a47c4938"
import script from "./DataTitle.vue?vue&type=script&lang=js"
export * from "./DataTitle.vue?vue&type=script&lang=js"
script.render = render

export default script